<template>






  <v-row justify="center">

<v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
<v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>





    <v-dialog v-model="dialogeditarvendedor" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h5">
          Editar Vendedor

           {{ vendedor }} 
        </v-card-title>

        <v-card-text>
          
<v-container>
  <v-row>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.nombre"
        label="Nombre"
        outlined
        dense
        required
      />
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.apellido"
        label="Apellido"
        outlined
        dense
        required
      />
    </v-col>

    <v-col cols="12" md="6">
  <v-text-field
    v-model="vendedor.identificador"
    label="Identificador"
    outlined
    dense
      @blur="buscarUsuario"
  />
</v-col>



 <v-col cols="12" md="6">
  <v-text-field
    v-model="vendedor.user.name"
    label="Nombre del Usuario"
    outlined
    dense
    disabled
  />
</v-col> 

 <v-col cols="12" md="6">
  <v-text-field
    v-model="vendedor.user.email"
    label="Email del Usuario"
    outlined
    dense
    disabled
  />
</v-col> 

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.numero_documento"
        label="Número de Documento"
        outlined
        dense
        type="number"
      />
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.fecha_nacimiento"
        label="Fecha de Nacimiento"
        type="date"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12">
      <v-text-field
        v-model="vendedor.direccion"
        label="Dirección"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.celular"
        label="Celular"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.correo_principal"
        label="Correo Principal"
        type="email"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12">
      <v-text-field
        v-model="vendedor.correo_secundario"
        label="Correo Secundario"
        type="email"
        outlined
        dense
      />
    </v-col>

  </v-row>
</v-container>




        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn     color="error" @click="closeDialog">Cancelar</v-btn>
          <v-btn   color="success" @click="guardarCambios">Registrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import vendedorService from "@/services/tienda/vendedorService.js";

import usuarioService from "@/services/usuarioService.js";


  import { 
   
  } from 'vuex'
export default {
  name: 'EditarVendedorDialog', // importante para el warning
  data() {
    return {

        mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: 5000,
      },
      dialogeditarvendedor: false,

       vendedores: [],
     
    vendedor: {
      id: '',
      nombre: '',
      apellido: '',
      identificador: '',
      numero_documento: '',
      fecha_nacimiento: '',
      direccion: '',
      celular: '',
      correo_principal: '',
      correo_secundario: '',
          user: {
            id:'',
            identificador:'',
            name: '',
             email: ''
            }
    },



    }
  }, mounted() {




 //   this.listarVendedoresAdmin();


  },


  methods: {

      buscarUsuario() {

    if (!this.vendedor.identificador) {
      return
    }

    this.getUsuarioParaVendedor(this.vendedor.identificador)
  },

  getUsuarioParaVendedor(identificador) {

    usuarioService
      .getUsuarioParaVendedor(identificador)
      .then((resposta) => {

  if (resposta.data.status) {
    this.vendedor.user.id = resposta.data.user.id
    this.vendedor.user.name = resposta.data.user.name
    this.vendedor.user.email = resposta.data.user.email
    this.vendedor.user.identificador = resposta.data.user.identificador
    this.vendedor.correo_principal=resposta.data.user.email;
  } else {
    this.vendedor.user.name = 'No encontrado'
    this.vendedor.user.email = 'No encontrado'
  }

})
      .catch(() => {


        this.vendedor.user.name = 'Ocurrio un error'
        this.vendedor.user.email = 'Ocurrio un error'
      })
  },


   
  getUsuarioParaVendedorInicio(identificador) {

    usuarioService
      .getUsuarioParaVendedor(identificador)
      .then((resposta) => {

  if (resposta.data.status) {
   this.vendedor.user.id = resposta.data.user.id
   this.vendedor.user.name = resposta.data.user.name
   this.vendedor.user.email = resposta.data.user.email
   this.vendedor.user.identificador = resposta.data.user.identificador

  } 

})
      .catch(() => {


        this.vendedor.user.name = 'Ocurrio un error'
        this.vendedor.user.email = 'Ocurrio un error'
      })
  },

    limpiar() {


     this.vendedor = {
  id: '',
  nombre: '',
  apellido: '',
  identificador: '',
  numero_documento: '',
  fecha_nacimiento: '',
  direccion: '',
  celular: '',
  correo_principal: '',
  correo_secundario: ''
  ,
          user: {
            id:'',
            identificador:'',
            name: '',
             email: ''
            }
}



    },
    
     listarVendedoresAdmin() {
      vendedorService
        .listarVendedoresAdmin()
        .then((resposta) => {
          //    console.log(resposta.data);
          this.vendedores = resposta.data;
        })

    },
    
    /**
     * Abre el diálogo y carga datos del vendedor
     */
    openDialog(vendedor) {
      // clonar para no modificar directo el objeto padre
    //  this.vendedor = { ...vendedor }


      this.limpiar();

Object.assign(this.vendedor, vendedor);

 

    this.getUsuarioParaVendedorInicio(vendedor.identificador)

   




      this.dialogeditarvendedor = true
    },
    /**
     * Cierra el diálogo
     */
    closeDialog() {
      this.dialogeditarvendedor = false
    },
    /**
     * Guarda los cambios en el servidor
     */
    guardarCambios() {
      vendedorService.update(this.vendedor)
        .then(respuesta => {

          console.log("Al actualizar");
          console.log(this.vendedor);

          // avisar al padre que actualice su lista
          this.$emit('actualizado')
          this.closeDialog()
        }).catch((errors) =>{

          let mensajeError = 'Ha ocurrido un error:\n';

  // Recorremos el array de errores del backend
  if (errors.response && errors.response.data && errors.response.data.errors) {
    errors.response.data.errors.forEach((err, index) => {
      mensajeError += `${index + 1}. ${err}\n`;
    });
  } else {
    mensajeError += 'Error desconocido';
  }

  // Asignamos al snackbar
  this.mensaje.text = mensajeError;
  this.mensaje.snackbar = true; // debe ser boolean
  this.mensaje.color = "error"; // fondo rojo
  this.mensaje.colorBtn = "red darken-2"; // color de botón contraste


  })
        
    }
  }
}
</script>
